(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Großhandel: sticky "Rückruf anfordern" on phones, hidden while hero or form is visible
  var sticky = document.querySelector('[data-ckw-sticky]');
  var hero = document.querySelector('[data-ckw-hero]');
  var form = document.getElementById('anfrage');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var heroIn = true, formIn = false;
    var upd = function () { sticky.classList.toggle('is-on', !heroIn && !formIn); };
    new IntersectionObserver(function (e) { heroIn = e[0].isIntersecting; upd(); }).observe(hero);
    if (form) new IntersectionObserver(function (e) { formIn = e[0].isIntersecting; upd(); }, { rootMargin: '0px 0px -25% 0px' }).observe(form);
  }

  // "Preis anfragen": tick the flavour in the form, scroll there, focus the first field
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ckw-ask]');
    if (!b) return;
    var name = b.getAttribute('data-ckw-ask');
    document.querySelectorAll('[data-ckw-sort]').forEach(function (cb) {
      if (cb.getAttribute('data-ckw-sort') === name) cb.checked = true;
    });
    if (form) form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var first = document.getElementById('ckw-firma');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 600);
  });

  // Coming from a product's "Preis anfragen" (?sorte=<handle>): tick that flavour
  try {
    var sorte = new URL(window.location.href).searchParams.get('sorte');
    if (sorte) {
      document.querySelectorAll('[data-ckw-handle]').forEach(function (cb) {
        if (cb.getAttribute('data-ckw-handle') === sorte) cb.checked = true;
      });
      var kind = document.querySelector('#anfrage input[name="contact[Anfrage]"]');
      if (kind) kind.value = 'Preisanfrage: ' + sorte;
    }
  } catch (err) {}

  // Artikel: mark the current section in the table of contents
  var links = document.querySelectorAll('.cka-side .cka-toc a');
  if (links.length && 'IntersectionObserver' in window) {
    var byId = {};
    links.forEach(function (a) { byId[decodeURIComponent(a.hash.slice(1))] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (!x.isIntersecting) return;
        links.forEach(function (a) { a.removeAttribute('aria-current'); });
        var a = byId[x.target.id];
        if (a) a.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-15% 0px -75% 0px' });
    document.querySelectorAll('.cka-prose h2[id]').forEach(function (h) { io.observe(h); });
  }
})();
